import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AdminDashboard from './pages/AdminDashboard';
import TrackOrderPage from './pages/TrackOrderPage';
import OrderStatusPage from './pages/OrderStatusPage';
import PaymentPage from './pages/PaymentPage';
import WishlistPage from './pages/WishlistPage';
import NotFoundPage from './pages/NotFoundPage';
import StatusPage from './pages/StatusPage';
import './App.css';

function AppContent({ cartCount, updateCartCount }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App">
      {!isAdminRoute && <Header cartCount={cartCount} />}
      <main className={isAdminRoute ? '' : 'main-content'}>
        <Routes>
          <Route path="/"              element={<HomePage onCartUpdate={updateCartCount} />} />
          <Route path="/product/:productId" element={<ProductDetailPage />} />
          <Route path="/cart"          element={<CartPage />} />
          <Route path="/checkout"      element={<CheckoutPage />} />
          <Route path="/about"         element={<AboutPage />} />
          <Route path="/contact"       element={<ContactPage />} />
          <Route path="/terms"         element={<TermsPage />} />
          <Route path="/privacy"       element={<PrivacyPage />} />
          <Route path="/admin"         element={<AdminDashboard />} />
          <Route path="/track-order"   element={<TrackOrderPage />} />
          <Route path="/order-status"  element={<OrderStatusPage />} />
          <Route path="/payment"       element={<PaymentPage />} />
          <Route path="/wishlist"      element={<WishlistPage />} />
          <Route path="/status"        element={<StatusPage />} />
          <Route path="*"              element={<NotFoundPage />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
}

function App() {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    return () => window.removeEventListener('storage', updateCartCount);
  }, []);

  const updateCartCount = () => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    const count = cart.reduce((sum, item) => sum + item.quantity, 0);
    setCartCount(count);
  };

  return (
    <Router>
      <AppContent cartCount={cartCount} updateCartCount={updateCartCount} />
    </Router>
  );
}

export default App;
